// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;
// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSThemeConfig.custom.products_per_page,
		// Optional
		loadProductFirst: false,
		styleScrollToTop: 'style2',
		defaultDisplay: boostPFSThemeConfig.custom.layout,
		showPlaceholderProductList: true,
        showAjaxCartOnAdd: false,
	},
  selector: {
		otpTopCartLink: 'nothing',
  }
};

(function() {
	BoostPFS.inject(this);
	
	ProductGridItem.prototype.compileTemplate = function(data) {
		if(!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
        // Custom for Cardtoons
		if (data.variants.length > 2) {
			var variantCount = 'From ';
		} else {
			var variantCount = '';	
		}
        var retailPrice = data['variants'][0]['price'];

      
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/
		
		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		// Add a specific class for grid item
		var itemGridWidthClass = '';
		var imageSize = '600x600';

		switch (boostPFSConfig.custom.products_per_row) {
			case 2:
				itemGridWidthClass = 'grid-2columns';
				break;
			case 3:
				itemGridWidthClass = 'grid-3columns';
				break;
			case 4:
				itemGridWidthClass = 'grid-4columns';
				break;
			case 5:
				itemGridWidthClass = 'grid-5columns';
				break;
		}
		itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

		// Add soldOut class
		var itemSoldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

		// Add soldOut label
		var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelGridHtml : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);
        
		var imgId = 'ProductCardImage-' + data.id;
		var wrapperId = 'ProductCardImageWrapper-' + data.id;
		var rangeClass = data.vendor;
		rangeClass = rangeClass.replace(/\s+/g, '-').toLowerCase();
		var typeClass = data.product_type;
        typeClass = typeClass.replace(/\s+/g, '-').toLowerCase();
		var productClass = rangeClass + ' ' + typeClass;
		var aspect_ratio = '';
        if (images.length > 0) {
			aspect_ratio = images[0]['width'] / images[0]['height'];
        }
		var imageOrientation = '';
		if (aspect_ratio < '1') {
			imageOrientation = 'portrait';
		}
		if (aspect_ratio == '1') {
			imageOrientation = 'square';
		}
        var altText = data.title.replace(/"/g, '&quot;');

		// Add Images
		var itemImagesHtml = '<div id="' + wrapperId + '" class="product-card-image">';
		itemImagesHtml += '<div class="product-card-image-inner">';
		itemImagesHtml += '<span class="' + productClass + ' ' + imageOrientation + '">';
		itemImagesHtml += '<img id="' + imgId + '" ' +
			'class="lazyload" ' +
			'src="' + Utils.getFeaturedImage(images, '300x300') + '" ' +
			'srcset="' + Utils.getFeaturedImage(images, '880x') + ' 880w, '  
					   + Utils.getFeaturedImage(images, '760x') + ' 760w" '
					   + Utils.getFeaturedImage(images, '640x') + ' 640w" '
					   + Utils.getFeaturedImage(images, '540x') + ' 540w" '
					   + Utils.getFeaturedImage(images, '440x') + ' 440w" '
					   + Utils.getFeaturedImage(images, '320x') + ' 320w" '
					   + Utils.getFeaturedImage(images, '280x') + ' 280w" '
					   + Utils.getFeaturedImage(images, '220x') + ' 220w" ' +
			'sizes="(min-width: 751px) 21vw,(min-width: 481px) 42vw, 90vw" ' +
			'alt="' + altText + '">';
		itemImagesHtml += '</span></div>';
		itemImagesHtml += '</div>';

		var image_size = boostPFSConfig.custom.max_height + 'x' + boostPFSConfig.custom.max_height;
		var max_width = images.length > 0 ? boostPFSConfig.custom.max_height * aspect_ratio : 0;
		itemImagesHtml += '<noscript><img class="grid-view-item__image" src="' + Utils.getFeaturedImage(images, image_size + '@2x') + '" alt="{{itemTitle}}" style="max-width: ' + max_width + 'px;"></noscript>';
		itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

		// Add Vendor
		var itemVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorGridHtml : '';
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);
      
		// Add Price
		var itemPriceHtml = buildPrice(data, onSale, priceVaries);
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

      // Add reviews 
      var itemReviewsHtml = '';
           if (Utils.getProductMetafield(data, 'judgeme', 'badge') !== null) {  
             console.log(Utils.getProductMetafield(data, 'judgeme', 'badge'))
             itemReviewsHtml += '<div class="jdgm-widget jdgm-preview-badge" data-id="" + data.id + >' + Utils.getProductMetafield(data, 'judgeme', 'badge') + '</div>'
        }
              
             itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewsHtml);

        // Add Option Size
		itemHtml = itemHtml.replace(/{{variantCount}}/g, variantCount);

        // Add Retail Price
		var itemretailpriceHtml = Utils.formatMoney(retailPrice, Globals.moneyFormat);
		itemHtml = itemHtml.replace(/{{retailPrice}}/g, itemretailpriceHtml);

      
		// Add main attribute
      itemHtml = itemHtml.replace(/{{p_id}}/g, data.id);
      itemHtml = itemHtml.replace(/{{p_h}}/g, data.handle);
      itemHtml = itemHtml.replace(/{{p_vid}}/g, data.variants[0].id);
      itemHtml = itemHtml.replace(/{{p_vp}}/g, data.variants[0].price);
       itemHtml = itemHtml.replace(/{{p_comp}}/g, data.variants[0].compare_at_price);
      itemHtml = itemHtml.replace(/{{p_sku}}/g, data.variants[0].sku);
      
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data, false));
      
		return itemHtml;
	}

	ProductListItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
        // Custom for Cardtoons
		var variantCount = data.variants.length;
		if (data.variants.length > 2) {
			var variantCount = 'From ';
		} else {
			var variantCount = '';	
		}
        var retailPrice = data['variants'][0]['price'];

		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/
	
		// Get Template
		var itemHtml = boostPFSTemplate.productListItemHtml;
	
		// Add onSale label
		var itemSaleLabel = onSale ? boostPFSTemplate.saleLabelListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);
	
		// Add soldOut label
		var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);
	
		// Add Thumbnail
		var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(images[0]['src'], '600x600') : boostPFSConfig.general.no_image_url;
		itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);
	
		// Add Vendor
		var itemSmallVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorSmallListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSmallVendor}}/g, itemSmallVendorHtml);
		var itemMediumVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorMediumListHtml : '';
		itemHtml = itemHtml.replace(/{{itemMediumVendor}}/g, itemMediumVendorHtml);
      
		// Add Price
		var itemPriceHtml = buildPrice(data, onSale, priceVaries);
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Add Option Size
		itemHtml = itemHtml.replace(/{{variantCount}}/g, variantCount);

        // Add Retail Price
		var itemretailpriceHtml = Utils.formatMoney(retailPrice, Globals.moneyFormat);
		itemHtml = itemHtml.replace(/{{retailPrice}}/g, itemretailpriceHtml);
	
		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data, false));
	
		return itemHtml;
	}

	// Build Image style
	function buildImageStyle(data) {
		var images = data.images_info;
		var imgId = 'ProductCardImage-' + data.id;
		var wrapperId = 'ProductCardImageWrapper-' + data.id;
		var imageStyle = '';
		if (images.length > 0) {
			var image = images[0];
			var width = boostPFSConfig.custom.max_height;
			var height = boostPFSConfig.custom.max_height;
			var aspect_ratio = image.width / image.height;
			var small_style = true;
			var container_aspect_ratio = width * 1.0 / height;

			if (image.aspect_ratio < 1.0) {
				var maximum_width = height * aspect_ratio;
				if (image.height <= height) {
					var maximum_height = image.height;
					maximum_width = image.width;
				} else {
					var maximum_height = height;
				}
			} else if (aspect_ratio < container_aspect_ratio) {
				var maximum_height = height / aspect_ratio;
				if (image.height <= height) {
					var maximum_height = image.height;
					var maximum_width = image.width;
				} else {
					var maximum_height = height;
					var maximum_width = height * aspect_ratio;
				}
			} else {
				var maximum_height = height / aspect_ratio;
				if (image.width <= width) {
					maximum_height = image.height;
					var maximum_width = image.width
				} else {
					var maximum_width = width;
					maximum_height = maximum_width / aspect_ratio;
				}
			}

			imageStyle += '<style>';
			if (small_style) imageStyle += '@media screen and (min-width: 750px) {';
			imageStyle += '#' + imgId + ' {' +
				'max-width: ' + maximum_width + 'px;' +
				'max-height: ' + maximum_height + 'px;' +
				'}' +
				'#' + wrapperId + ' {' +
				'max-width: ' + maximum_width + 'px;' +
				'max-height: ' + maximum_height + 'px;' +
				'}';
			if (small_style) imageStyle += '}';

			if (small_style) {
				if (aspect_ratio < 1) {
					maximum_width = 750 * aspect_ratio;
				} else {
					if (image.width < 750) {
						maximum_width = image.width;
					} else {
						maximum_width = 750;
					}
				}
				imageStyle += '@media screen and (max-width: 749px) {'
				imageStyle += '#' + imgId + ' {' +
					'max-width: ' + maximum_width + 'px;' +
					'max-height: 750px;' +
					'}' +
					'#' + wrapperId + ' {' +
					'max-width: ' + maximum_width + 'px;' +
					'}';
				imageStyle += '}';
			}
			imageStyle += '</style>';
		}
		return imageStyle;
	}

	function buildPrice(data, onSale, priceVaries) {
		var priceHtml = '',
			onSaleClass = onSale ? ' price--on-sale' : '';
	
		priceHtml += '<dl class="price' + onSaleClass + '" data-price>';
        // Custom: Removed vendor
		priceHtml += '<div class="price__regular">';
		priceHtml += '<dt>';
		priceHtml += '<span class="visually-hidden visually-hidden--inline">' + boostPFSConfig.label.regular_price + '</span>';
		priceHtml += '</dt>';
		priceHtml += '<dd>';
		priceHtml += '<span class="price-item price-item--regular" data-regular-price>';
		if (data.available) {
			if (onSale) {
				priceHtml += Utils.formatMoney(data.compare_at_price_min, Globals.moneyFormat);
			} else {
				priceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat);
			}
		} else {
			priceHtml += boostPFSConfig.label.sold_out;
		}
		priceHtml += '</span>';
		priceHtml += '</dd>';
		priceHtml += '</div>';
		priceHtml += '<div class="price__sale">';
		priceHtml += '<dt>';
		priceHtml += '<span class="visually-hidden visually-hidden--inline">' + boostPFSConfig.label.sale_price + '</span>';
		priceHtml += '</dt>';
		priceHtml += '<dd>';
		priceHtml += '<span class="price-item price-item--sale" data-sale-price>';
		priceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat);
		priceHtml += '</span> ';
		priceHtml += '<span class="price-item__label" aria-hidden="true">' + boostPFSConfig.label.sale + '</span>';
		priceHtml += '</dd>';
		priceHtml += '</div>';
		priceHtml += '</dl>';
	
		return priceHtml;
	}
  

  
	/// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;
		// Build Previous
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
		// Create page items array
		var beforeCurrentPageArr = [];
      	for (var iBefore = currentPage - 1; iBefore > currentPage - 2 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 3 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 3 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);
		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 2 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 2 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 2 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}
		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
		return paginationHtml;
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	// Build Display type
	ProductDisplayType.prototype.compileTemplate = function() {
		var itemHtml = '<span>View As </span>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"><span class="fallback-text">Grid view</span></span></a>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"><span class="fallback-text">List view</span></span></a>';
		itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);

		return itemHtml;
	};

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
		if (!data) data = this.data;
		var productSelector = jQ(Selector.products);
		if (Globals.queryParams.display == 'list') {
			if (productSelector.children('.list-view-items').length == 0) {
				productSelector.children().wrapAll('<ul class="list-view-items"></ul>');
			}
			productSelector.removeClass('grid grid--uniform grid--view-items');
		} else {
			if (productSelector.children('.list-view-items').length > 0) {
				productSelector.children('.list-view-items').children().unwrap();
			}
			productSelector.addClass('grid grid--uniform grid--view-items');
		}
    
	}

	// Build Additional Elements
	FilterResult.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
		var totalProduct = '';
		if (data.total_product == 1) {
			totalProduct = boostPFSConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
		} else {
			totalProduct = boostPFSConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
		}
		jQ('.boost-pfs-filter-total-product').html(totalProduct);
	};
    BoostOTP.AjaxCart.prototype.onSucess = function(data, $addingLabel, $errorLabel) {
    this.changeButtonLabel($addingLabel, Labels.action_list.atcAddingToCartBtnLabel, Labels.action_list.atcAddedToCartBtnLabel);
    setTimeout(() => {
        this.changeButtonLabel($addingLabel, Labels.action_list.atcAddedToCartBtnLabel, Labels.action_list.atcAvailableLabel);
    }, 700);
    var isOpenCart = Settings.getSettingValue('general.showAjaxCartOnAdd');
    this.getCart(isOpenCart);
    console.log(data)
    var minicartHtml = '';
                	minicartHtml += '<div class="cart-popup" data-cart-popup="" tabindex="-1">';
                    minicartHtml += '<div class="cart-popup__header">';
                    minicartHtml += '<h2 id="CartPopupHeading" class="cart-popup__heading">Just added to your cart</h2>';
                    minicartHtml += '<button class="cart-popup__close" aria-label="Close" data-cart-popup-close=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 40 40"><path d="M23.868 20.015L39.117 4.78c1.11-1.108 1.11-2.77 0-3.877-1.109-1.108-2.773-1.108-3.882 0L19.986 16.137 4.737.904C3.628-.204 1.965-.204.856.904c-1.11 1.108-1.11 2.77 0 3.877l15.249 15.234L.855 35.248c-1.108 1.108-1.108 2.77 0 3.877.555.554 1.248.831 1.942.831s1.386-.277 1.94-.83l15.25-15.234 15.248 15.233c.555.554 1.248.831 1.941.831s1.387-.277 1.941-.83c1.11-1.109 1.11-2.77 0-3.878L23.868 20.015z" class="layer"></path></svg></button>';
                    minicartHtml += '</div>';
                    minicartHtml += '<div class="cart-popup-item">';
                    minicartHtml += '<div class="cart-popup-item__image-wrapper" data-cart-popup-image-wrapper=""><img src="'+ Utils.optimizeImage(data.image,'100x') +'" alt="'+ data.title +'" class="cart-popup-item__image" data-cart-popup-image=""></div>';
                    minicartHtml += '<div class="cart-popup-item__description">';
                    minicartHtml += '<div>';
                    minicartHtml += '<h3 class="cart-popup-item__title" data-cart-popup-title="">'+ data.title +'</h3>';
                	var options_with_values = data.options_with_values;
                	minicartHtml += '<ul class="product-details" aria-label="Product details" data-cart-popup-product-details="">';
                	if(options_with_values !== null && options_with_values.length > 0){
                      for(var i = 0; i < options_with_values.length; i++){
                        if(options_with_values[i].name.toLowerCase() !== 'title' && options_with_values[i].value.toLowerCase() !=='default title'){
                        	minicartHtml += '<li class="product-details__item product-details__item--variant-option">'+ options_with_values[i].name +': '+ options_with_values[i].value +'</li>';
                        }
                      }
                    }
                	minicartHtml += '</ul>';
                  	minicartHtml += '</div>';
                    minicartHtml += '<div class="cart-popup-item__quantity">';
                    minicartHtml += '<span class="visually-hidden" data-cart-popup-quantity-label="">Quantity: '+ data.quantity +'</span>';
                    minicartHtml += '<span aria-hidden="true">Qty:</span>';
                    minicartHtml += '<span aria-hidden="true" data-cart-popup-quantity="">'+ data.quantity +'</span>';
                    minicartHtml += '</div>';
                    minicartHtml += '</div>';
                    minicartHtml += '</div>';
					minicartHtml += '<a href="/cart" class="cart-popup__cta-link btn btn--secondary-accent">';
                    minicartHtml += 'View cart (<span data-cart-popup-cart-quantity=""></span>)';
                    minicartHtml += '</a>';
					minicartHtml += '<div class="cart-popup__dismiss">';
                    minicartHtml += '<button class="cart-popup__dismiss-button text-link text-link--accent" data-cart-popup-dismiss="">';
                    minicartHtml += 'Continue shopping';
                    minicartHtml += '</button>';
                    minicartHtml += '</div>';
                  	minicartHtml += '</div>';
                	jQ.getJSON('/cart.js', function(cart){ 
                        var cartItemCounter = cart.item_count;
                      	jQ('#CartCount').find('[data-cart-count]').html(cartItemCounter);
                      	jQ('#CartCount').removeClass("hide");
                      	jQ('[data-cart-popup-cart-quantity]').html(cartItemCounter);
                    });
                	jQ(".cart-popup-wrapper").html(minicartHtml).css({'display':'block','transform':'translateY(0)'});
                	jQ('.cart-popup__close,.cart-popup__dismiss-button').click(function(){
                        jQ(".cart-popup-wrapper").css('transform', 'translateY(-130%)');
                    });
   }
  
})();